import firebase from "firebase";
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-regular-svg-icons";

const ResourceWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  margin-bottom: 16px;
  h3 {
    margin: 0;
  }
  hgroup {
    margin-left: 16px;
  }
  .icon {
    width: 64px;
    height: 64px;

    background: #fafafa;
    border: 2px solid #efefef;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

type ResourceWrapperProps = {
  path?: string;
  name?: string;
  type?: string;
};

const ResourceWrapperComponent = ({
  path,
  name,
  type,
}: ResourceWrapperProps) => {
  return (
    <ResourceWrapper
      onClick={() => {
        firebase
          .storage()
          .ref(path)
          .getDownloadURL()
          .then((url) => {
            window.open(url);
          });
      }}
    >
      <div className="icon">
        <FontAwesomeIcon icon={faFileAlt} size="2x" />
      </div>
      <hgroup>
        <h3>{name}</h3>
        {type}
      </hgroup>
    </ResourceWrapper>
  );
};

export default ResourceWrapperComponent;
